import moment from 'moment'
import constant from '@/utils/constant'

const getYsterdayDate = () => {
  let yesterdayDate = moment()
    .subtract(1, 'days')
    .format('YYYY-MM-DD')
  if (moment(yesterdayDate) < moment(constant.startDate)) {
    yesterdayDate = constant.startDate
  }
  return yesterdayDate
}
const getMonthStartDate = () => {
  let monthStartDate = moment()
    .startOf('month')
    .format('YYYY-MM-DD')
  if (moment(monthStartDate) < moment(constant.startDate)) {
    monthStartDate = constant.startDate
  }
  return monthStartDate
}
const getMonthEndDate = () => {
  let monthEndDate = moment()
    .endOf('month')
    .format('YYYY-MM-DD')
  if (moment(monthEndDate) < moment(constant.startDate)) {
    monthEndDate = constant.startDate
  }
  if (moment(yesterdayDate) < moment(monthEndDate)) {
    monthEndDate = yesterdayDate
  }
  return monthEndDate
}
const getOneMonthAgoStartDate = () => {
  let oneMonthAgoStartDate = moment()
    .subtract(1, 'months')
    .startOf('month')
    .format('YYYY-MM-DD')
  if (moment(oneMonthAgoStartDate) < moment(constant.startDate)) {
    oneMonthAgoStartDate = constant.startDate
  }
  return oneMonthAgoStartDate
}
const getOneMonthAgoEndDate = () => {
  let oneMonthAgoEndDate = moment()
    .subtract(1, 'months')
    .endOf('month')
    .format('YYYY-MM-DD')
  if (moment(oneMonthAgoEndDate) < moment(constant.startDate)) {
    oneMonthAgoEndDate = constant.startDate
  }
  return oneMonthAgoEndDate
}

const yesterdayDate = getYsterdayDate()
const monthStartDate = getMonthStartDate()
const monthEndDate = getMonthEndDate()
const oneMonthAgoStartDate = getOneMonthAgoStartDate()
const oneMonthAgoEndDate = getOneMonthAgoEndDate()

export {
  yesterdayDate,
  monthStartDate,
  monthEndDate,
  oneMonthAgoStartDate,
  oneMonthAgoEndDate
}
